import type { Theme, ThemeOptionVariant, ThemeOption, Tokens, PaletteMode } from './augmentation'

// reason: i need the Theme to be augmented here
// eslint-disable-next-line import-x/order
import { createTheme as createMuiTheme } from '@mui/material'
import { breakpoints } from './breakpoints'
import { createComponents } from './components'
import { miscellaneous } from './miscellaneous'
import { createDhlPalette, paletteDhlDark, paletteDhlLight } from './tenants/dhl'
import { spacing } from './spacing'
import { createTypography, createTypographyPatched } from './typography'
import { elevation } from './elevation'
import { zIndex } from './z-index'

export type { Theme, ThemeOptionVariant, ThemeOption, Tokens, PaletteMode }

export const createTheme = (
  mode: PaletteMode,
  variant: ThemeOptionVariant,
  options?: Omit<ThemeOption, 'variant'>,
  paletteOverride?: ReturnType<typeof createDhlPalette>
): Theme => {
  const palette = paletteOverride ?? createDhlPalette(mode)

  const typography = createTypography()
  const misc = miscellaneous({ palette, disableActiveState: options?.disableActiveState, variant })

  const components = createComponents({ palette, typography, variant, misc, elevation }, mode, options)

  return createMuiTheme({
    breakpoints,
    components,
    misc,
    palette,
    spacing,
    shape: {
      borderRadius: 4,
    },
    typography,
    variant,
    zIndex,
    cssVariables: options?.useCssVariables ? { cssVarPrefix: 'dhl' } : false,
    elevation,
  })
}

/**
 * JIRA-#DS-53
 * Temporary solution to merge two themes until we are finished migrating
 */
export const rawThemeNew = (mode: PaletteMode, variant: ThemeOptionVariant, options?: Omit<ThemeOption, 'variant'>) => {
  const palette = (mode === 'light' ? paletteDhlLight : paletteDhlDark) as Tokens['palette']

  const typography = createTypographyPatched()
  const misc = miscellaneous({ palette, disableActiveState: options?.disableActiveState, variant })

  const components = createComponents({ palette, typography, variant, misc, elevation }, mode, options)

  return {
    breakpoints,
    components,
    misc,
    palette,
    spacing,
    shape: {
      borderRadius: 4,
    },
    typography,
    variant,
    zIndex,
    // @todo determine how far we want to push tenant(Id); apply it also to the cssVarPrefix??
    cssVariables: options?.useCssVariables ? { cssVarPrefix: 'dhl' } : false,
    elevation,
  }
}
